import { render, staticRenderFns } from "./DownloadAllDocumentsButton.vue?vue&type=template&id=2af51ce4&scoped=true&"
import script from "./DownloadAllDocumentsButton.vue?vue&type=script&lang=js&"
export * from "./DownloadAllDocumentsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af51ce4",
  null
  
)

export default component.exports